// @ts-check
import React from 'react';
import SpinnerButton from 'shared/components/SpinnerButton';
import classes from './LoadMoreButton.module.scss';

const LoadMoreButton = ({ disabled, onClick }) => (
  <SpinnerButton className={classes.LoadMoreButton} disabled={disabled} onClick={onClick}>
    Load More...
  </SpinnerButton>
);

export default LoadMoreButton;
